// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__28asI","header":"Form_header__2ZU5o","title":"Form_title__AnRvo","body":"Form_body__2u2Mq"};